import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaCheckCircle, FaInfoCircle, FaGlobeAmericas } from "react-icons/fa";
import {activatorUserAdding, deleteUserTelephoneAss} from "../../auth";
import PhoneInput, { parsePhoneNumber, formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber, getCountryCallingCode  } from 'react-phone-number-input'
import { MdSmartphone,  MdDeleteForever } from "react-icons/md";
// Address redesign (2026-08-31): reuses the SAME countries.json data
// FormAddress already uses -- no second country list -- and the SAME
// Rolle.CommercialRole() gate FormAddress already uses for the shop-name field.
// FormAddress itself is intentionally left untouched: it's shared by
// checkout/AddressUser/FormBusiness/Stripe card forms, well outside this
// patch's "address modal in userAddingRoleByToken only" scope.
// Country / ZIP / State / City: shared Elakay address location fields
// (2026-10-02, replaces the full-country-file download + ZIP-length lookup).
import AddressLocationSelector from "../../pageInside/addressLocation/AddressLocationSelector";
import { toLocationValue, fromLocationValue } from "../../pageInside/addressLocation/addressLocationData";
import { CommercialRole } from "../../pageInside/Rolle";
import en from 'react-phone-number-input/locale/en.json'
import { elakayAutoText } from "../../pageInside/dataElakay";
import { countryFlagEmoji } from "../../../utils/countryFlagEmoji";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["pageEditForm"]?.[key] || fallback;

// Same email pattern userAssociateValidator/userSignupValidator already
// enforce server-side -- one rule, not a second invented one, just
// surfaced client-side too so a bad address never even reaches the API.
const EMAIL_PATTERN = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,8})+$/;
const isValidEmailFormat = (value) => EMAIL_PATTERN.test(String(value || "").trim());

// Password criteria (spec §4): mirrors userAssociateValidator's own
// user.password rule exactly (6+ chars, upper+lower, a digit) -- not a
// stricter/invented one.
const passwordCriteria = (value) => ({
    length: String(value || "").length >= 6,
    case: /[a-z]/.test(value || "") && /[A-Z]/.test(value || ""),
    digit: /\d/.test(value || ""),
});

const PageEditForm = (props) => {
    const {
        editShoose,
        infoSource,
        userInfo,
        token,
        setUserInfo,
        relaodFonctionToken,
        setShowEditNameModal
        } = props
    __setElakayInfoSource(infoSource);



    let objSelName = {
        selFirtName: true,
        selLastName: false
    }

    const [selectName, setSelectName] = useState(objSelName)
    const {
        selFirtName,
        selLastName
    } = selectName

    // Independent show/hide per field (real bug fix -- a single shared
    // showPassword state used to toggle BOTH New password and Confirm
    // password at once).
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    // Prevents a double click firing two API calls at once (spec §22, TEST
    // 8) -- the ONE guard every form (name/email/password/phone/address)
    // routes through, since they all share this same clickSubmit.
    const [submitting, setSubmitting] = useState(false)
    const [emailTouched, setEmailTouched] = useState(false)
    // Phone stays a multi-entry list (chip list + "add another", spec
    // §10/§26) -- unlike every other field here, a successful add should
    // NOT close the modal (so several numbers can be added in one sitting),
    // just clear the input and show a brief success message instead.
    const [phoneAdded, setPhoneAdded] = useState(false)
    // Address redesign: blur-based per-field errors, same idiom as
    // emailForm's emailTouched above -- not a new validation pattern.
    const [touchedAddressFields, setTouchedAddressFields] = useState({})

    let userValue ={
        firstname: userInfo.firstname,
        lastname: userInfo.lastname,
        email: userInfo.email,
        password: "",
        passwordConfirmation: "",
        error: "",
        success: false
    }
    let objAdress ={
        firstName: userInfo.address?.length > 0 ? userInfo.address[0].firstName : '',
        lastName: userInfo.address?.length > 0 ?  userInfo.address[0].lastName: '',
        shopName: userInfo.address?.length > 0 ?  userInfo.address[0].shopName: '',
        tel: userInfo.address?.length > 0 ? userInfo.address[0].tel: '',
        Address1: userInfo.address?.length > 0 ? userInfo.address[0].Address1: '',
        Address2: userInfo.address?.length > 0 ? userInfo.address[0].Address2: '',
        city: userInfo.address?.length > 0 ? userInfo.address[0].city: '',
        State: userInfo.address?.length > 0 ? userInfo.address[0].State: '',
        postalCode: userInfo.address?.length > 0 ? userInfo.address[0].postalCode: '',
        country: userInfo.address?.length > 0 ? userInfo.address[0].country: '',
        error: ""
    }

    const [adress, setAdress] = useState(objAdress);
    const [values, setValues] = useState(userValue)
    const [phone, setPhone] = useState()
    const { firstname, lastname, email, password, passwordConfirmation, error} = values;

 const [geoRequirements, setGeoRequirements] = useState({ postalRequired: true, stateRequired: true })

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };


    const handleSelectName = (a, b) => {

        setSelectName({
            selFirtName: a,
            selLastName: b
            })
    };

    const showError = () => (
        <div
            className="alert alert-danger"
            style={{ display: error ? "" : "none" }}
        >
            {error}
        </div>
    );

    const clickSubmit =  (fileName, event) => {
         event.preventDefault();
        if (submitting) return; // double-click guard (spec §22, TEST 8)
        let userInfo
        if(fileName === 'user'){
        if(selFirtName && !selLastName) {
            userInfo ={firstname}
        }else if(!selFirtName && selLastName){
            userInfo ={lastname}
        }else if(selFirtName && selLastName){
            userInfo ={lastname, firstname}
        }
    }else if(fileName === 'email'){
        fileName =  'user'
        userInfo ={email}
    }else if(fileName === "password"){
          fileName =  'user'
        userInfo ={password, passwordConfirmation}
    }else if(fileName === 'telephone'){
        userInfo ={ "country": en[parsePhoneNumber(phone).country], "abrCountry": parsePhoneNumber(phone).country, "ariaCode": getCountryCallingCode(parsePhoneNumber(phone).country) , "National": formatPhoneNumber(phone), "International": formatPhoneNumberIntl(phone)}
    }else if(fileName === 'address'){
            userInfo = adress
    }

        setSubmitting(true)
         activatorUserAdding( token, fileName , userInfo, true).then(data => {
             if (data.error) {
                 setSubmitting(false)
                 setValues({ ...values, error: data.error, success: false });
             } else {
                 if(!data){
                     setSubmitting(false)
                     setValues({ ...values, error: __elakayText("t001", "BAD REQUEST or email is not ok"), success: false });
                 }else{
                 userValue.success = true
                //  setValues(userValue);
                setSubmitting(false)
                setUserInfo(data)
                if (fileName === 'telephone') {
                    // Stay open -- clear the input and show a brief success
                    // message instead of closing (spec §10/§26).
                    setPhone(undefined)
                    setPhoneAdded(true)
                } else {
                    setShowEditNameModal(false)
                }
                //  setPagesUser(bnTelephone)
             }
             }
         });;
     };

     const DeleteTelephone = (id , event) => {
           event.preventDefault();
        deleteUserTelephoneAss(token, id).then(response => {
            if (response.error) {
            } else {
                // setUserInfo(response)
                relaodFonctionToken()
                // setValues(response)
            }
        });
    }

    // Cancel + primary Save/Update button, shared by every form below
    // (spec §17/§19): replaces each form's own full-width "EDIT" button.
    // `disabled` is each form's own "nothing useful to save yet" check;
    // `submitting` (the double-click guard) always applies on top of it.
    const modalFooter = (fileName, saveLabel, disabled = false) => (
        <div className="uart-modal-actions">
            <button
                type="button"
                className="uart-btn-cancel"
                disabled={submitting}
                onClick={() => setShowEditNameModal(false)}
            >
                {elakayAutoText("h_uart_cancel", "Cancel")}
            </button>
            <button
                type="button"
                onClick={(e)=>clickSubmit(fileName, e)}
                className="uart-btn-save"
                disabled={submitting || disabled}
            >
                {submitting
                    ? <><span className="uart-spin" aria-hidden="true">⟳</span>{elakayAutoText("h_uart_saving", "Saving…")}</>
                    : saveLabel}
            </button>
        </div>
    );

const firtLastName =()=>{
    return <div className="uart-edit-form-section">
        <div className="uart-name-mode-group" role="radiogroup" aria-label={elakayAutoText("h_uart_nameMode", "Name display mode")}>
            <label className={`uart-name-mode-option${selFirtName && !selLastName ? " is-checked" : ""}`} htmlFor="First_Name">
                <input
                    onChange={()=>handleSelectName(true, false)}
                    type="radio"
                    name="Full_Name"
                    id="First_Name"
                    checked={selFirtName && !selLastName}
                />
                {infoSource.language(infoSource, 'label', "fisrtName")}
            </label>
            <label className={`uart-name-mode-option${!selFirtName && selLastName ? " is-checked" : ""}`} htmlFor="Last_Name">
                <input
                    onChange={()=>handleSelectName(false, true)}
                    type="radio"
                    name="Full_Name"
                    id="Last_Name"
                    checked={!selFirtName && selLastName}
                />
                {infoSource.language(infoSource, 'label', "lastName")}
            </label>
            <label className={`uart-name-mode-option${selFirtName && selLastName ? " is-checked" : ""}`} htmlFor="Full_Name">
                <input
                    onChange={()=> handleSelectName(true, true)}
                    type="radio"
                    name="Full_Name"
                    id="Full_Name"
                    checked={selFirtName && selLastName}
                />
                {infoSource.language(infoSource, 'label', "fullName")}
            </label>
        </div>

   {selFirtName && <div className="form-label-group uart-field">
                    <label className="text-muted" htmlFor="firstname">{infoSource.laguangeElakay('label', infoSource.languageAPI).fisrtName}</label>
                    <input autoComplete="off" onChange={handleChange("firstname")} value={firstname} type="text" name="firstname" id="firstname" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserPageEditForm.t001} required/>
                </div>}

    {selLastName  && <div className="form-label-group uart-field">
                    <label htmlFor="lastname">{infoSource.laguangeElakay('label', infoSource.languageAPI).lastName}</label>
                    <input autoComplete="off" onChange={handleChange("lastname")} value={lastname} type="text" name="lastname" id="lastname" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserPageEditForm.t002} required />
        </div>}
        {modalFooter('user', elakayAutoText("h_uart_saveChanges", "Save changes"), (selFirtName && !firstname?.trim()) || (selLastName && !lastname?.trim()))}
    </div>
}

const emailForm =()=>{
    const emailInvalid = emailTouched && email && !isValidEmailFormat(email)
    return <div className="uart-edit-form-section">

                <div className="form-label-group uart-field">
                    <label htmlFor="inputEmail">{infoSource.laguangeElakay('label', infoSource.languageAPI).email}</label>
                    <input
                        autoComplete="off"
                        onChange={handleChange("email")}
                        onBlur={() => setEmailTouched(true)}
                        value={email}
                        type="email"
                        name="email"
                        id="inputEmail"
                        className="form-control"
                        placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserPageEditForm.t003}
                        aria-invalid={emailInvalid ? "true" : "false"}
                        required
                    />
                    {emailInvalid
                        ? <p className="uart-field-error">{elakayAutoText("h_uart_invalidEmail", "Please enter a valid email address.")}</p>
                        : <p className="uart-field-hint">{elakayAutoText("h_uart_emailHint", "We'll use this email to send you important updates.")}</p>}
                </div>
        {modalFooter("email", elakayAutoText("h_uart_saveChanges", "Save changes"), !email || !isValidEmailFormat(email))}
    </div>
}
const passwordForm =()=>{
    const criteria = passwordCriteria(password)
    const criteriaList = [
        { key: "length", label: elakayAutoText("h_uart_pwCriteriaLength", "At least 6 characters") },
        { key: "case", label: elakayAutoText("h_uart_pwCriteriaCase", "Include uppercase and lowercase letters") },
        { key: "digit", label: elakayAutoText("h_uart_pwCriteriaDigit", "Include a number") },
    ]
    return <div className="uart-edit-form-section">
<div className="form-label-group uart-field">
    <label htmlFor="inputPassword">{elakayAutoText("h_uart_newPassword", "New password")}</label>
    <div className="uart-input-wrapper">
        <input onChange={handleChange("password")} value={password} type={showNewPassword ? "text" : "password"} name="password" id="inputPassword" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserPageEditForm.t004} aria-invalid={passwordConfirmation !== "" && password !== passwordConfirmation} />
        <button type="button" className="uart-password-toggle" onClick={() => setShowNewPassword((v) => !v)} aria-label={showNewPassword ? elakayAutoText("h_e40123b4e7879a", "Hide password") : elakayAutoText("h_044b852f30b636", "Show password")}>{showNewPassword ? <FaEyeSlash /> : <FaEye />}</button>
    </div>
</div>

<div className="uart-password-criteria">
    {criteriaList.map((c) => (
        <span className={`uart-password-criterion${criteria[c.key] ? " is-met" : ""}`} key={c.key}>
            <FaCheckCircle size={12} />{c.label}
        </span>
    ))}
</div>

<div className="form-label-group uart-field uart-password-field">
    <label htmlFor="inputPassword2">{elakayAutoText("h_uart_confirmNewPassword", "Confirm new password")}</label>
    <div className="uart-input-wrapper">
        <input onChange={handleChange("passwordConfirmation")} value={passwordConfirmation} type={showConfirmPassword ? "text" : "password"} name="passwordConfirmation" id="inputPassword2" className="form-control" placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserPageEditForm.t005} aria-invalid={passwordConfirmation !== "" && password !== passwordConfirmation} required />
        <button type="button" className="uart-password-toggle" onClick={() => setShowConfirmPassword((v) => !v)} aria-label={showConfirmPassword ? elakayAutoText("h_e40123b4e7879a", "Hide password") : elakayAutoText("h_044b852f30b636", "Show password")}>{showConfirmPassword ? <FaEyeSlash /> : <FaEye />}</button>
    </div>
    {passwordConfirmation !== "" && password !== passwordConfirmation && (
        <p className="uart-field-error">{elakayAutoText("h_uart_passwordMismatch", "Passwords do not match.")}</p>
    )}
</div>
    {modalFooter(
        "password",
        elakayAutoText("h_uart_updatePassword", "Update password"),
        !password || !passwordConfirmation || password !== passwordConfirmation || !criteria.length || !criteria.case || !criteria.digit
    )}
    </div>
}
const telephoneForm =()=>{
    const canSavePhone = phone && isValidPhoneNumber(phone)
    const hasPhones = userInfo.telephone && userInfo.telephone.length > 0
    return <div className="uart-edit-form-section">
                    {phoneAdded && (
                        <div className="uart-alert uart-alert-success uart-inline-success" role="status">
                            {elakayAutoText("h_uart_phoneAddedSuccess", "Phone number added successfully!")}
                        </div>
                    )}
                    {hasPhones ? (
                        <div className="uart-phone-list">
                            {userInfo.telephone.map((k,i)=>(
                                <div className="uart-phone-chip" key={k._id || i}>
                                    <span className="uart-info-icon"><MdSmartphone/></span>
                                    <span className="uart-phone-chip-number">{k.International}</span>
                                    <button
                                        type="button"
                                        onClick={(e) => DeleteTelephone(k._id, e)}
                                        className="uart-delete-icon-btn"
                                        aria-label={elakayAutoText("h_uart_removePhone", "Remove this phone number")}
                                    >
                                        <MdDeleteForever />
                                    </button>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="uart-phone-list-empty">{elakayAutoText("h_uart_noPhoneYet", "You haven't added a phone number yet.")}</p>
                    )}
                    <div className="uart-field">
                        <label className="uart-phone-add-label" htmlFor="uart-add-phone-input">
                            {elakayAutoText("h_uart_addAnotherPhone", "Add a phone number")}
                        </label>
                        <PhoneInput
                            id="uart-add-phone-input"
                            className="uart-phone-input"
                            countrySelectProps={{ unicodeFlags: true }}
                            placeholder={infoSource.laguangeElakay('label', infoSource.languageAPI).enterPhoneNumber}
                            value={phone}
                            onChange={(next) => { setPhone(next); if (phoneAdded) setPhoneAdded(false); }}
                        />
                        {phone && !isValidPhoneNumber(phone) && (
                            <p className="uart-field-error">{elakayAutoText("h_uart_invalidPhone", "Please enter a valid phone number.")}</p>
                        )}
                        <p className="uart-field-hint">{elakayAutoText("h_uart_phonePrivacyHint", "We'll never share your number with anyone.")}</p>
                    </div>
    {modalFooter('telephone', infoSource.laguangeElakay('Button', infoSource.languageAPI).addPhone, !canSavePhone)}
    </div>
}

// Redesign (2026-08-31): was a plain <FormAddress> wrapped in its own heavy
// gray "Your Address" header + border block (BorderActive defaulted true),
// with FormAddress's OWN Cancel/Save hidden via btnCancel/btnEdit={false}
// but no validity check ever wired into THIS file's modalFooter (it was
// called with no `disabled` arg at all -- Save was always clickable, unlike
// every other field's form here). Reuses the exact same state (adress/
// setAdress), the exact same zip-autofill idiom (areStringsSameLength) and
// the exact same country data (countries.json) FormAddress already used --
// just laid out as a real 2-column grid instead of delegating to the
// (shared, higher-blast-radius) FormAddress component.
const adressForm = () => {
    const {
        firstName, lastName, shopName, tel, Address1, city, State, postalCode, country
    } = adress;

    const handleAddressChange = (name) => (event) => {
        setAdress({ ...adress, [name]: event.target.value, error: false });
    };
    // Location fields only; every other address field is kept.
    const handleLocationChange = (location) =>
        setAdress((prev) => ({ ...fromLocationValue(prev, location), error: false }));

    const touchAddressField = (name) => () =>
        setTouchedAddressFields((t) => (t[name] ? t : { ...t, [name]: true }));

    // Spec's own minimum list (§11) -- country/ZIP/city/state/address
    // line 1/first/last name. tel and shopName stay part of the payload
    // (never stripped -- the User.address schema already has them, no new
    // DB fields) but neither the schema nor the spec requires them, so
    // they don't gate Save.
    const REQUIRED_FIELDS = [
        ["country", country], ["city", city], ["Address1", Address1], ["firstName", firstName], ["lastName", lastName],
        ...(geoRequirements.postalRequired ? [["postalCode", postalCode]] : []),
        ...(geoRequirements.stateRequired ? [["State", State]] : []),
    ];
    const addressValid = REQUIRED_FIELDS.every(([, value]) => String(value || "").trim() !== "");
    const fieldError = (name, value) =>
        touchedAddressFields[name] && !String(value || "").trim()
            ? <p className="uart-field-error">{elakayAutoText("h_uart_addressFieldRequired", "This field is required.")}</p>
            : null;

    return <div className="uart-edit-form-section uart-address-form">
        <div className="uart-address-grid">
            <AddressLocationSelector
                idPrefix="uart-address"
                value={toLocationValue(adress)}
                onChange={handleLocationChange}
                onRequirementsChange={setGeoRequirements}
                onBlurField={(name) => touchAddressField(name === "state" ? "State" : name)()}
                countryOptionLabel={(c) => `${countryFlagEmoji(c.code)} ${c.name}`}
                emptyCountryLabel={infoSource.laguangeElakay("label", infoSource.languageAPI).pleaseSelect}
                labels={{ country: <><FaGlobeAmericas className="uart-field-label-icon" aria-hidden="true" />{infoSource.laguangeElakay("label", infoSource.languageAPI).country}</> }}
                classNames={{ field: "uart-field uart-address-field", input: "form-control", hint: "uart-field-hint", error: "uart-field-error", status: "uart-address-field--full" }}
                hints={{
                    country: elakayAutoText("h_formaddress_hint_country", "The country this address is in."),
                    postalCode: elakayAutoText("h_addrloc_hint_postal", "Type it to fill in the state and the city, or choose them below."),
                }}
                errors={{
                    country: touchedAddressFields.country && !country ? elakayAutoText("h_uart_addressFieldRequired", "This field is required.") : null,
                    postalCode: touchedAddressFields.postalCode && geoRequirements.postalRequired && !String(postalCode || "").trim() ? elakayAutoText("h_uart_addressFieldRequired", "This field is required.") : null,
                    state: touchedAddressFields.State && geoRequirements.stateRequired && !String(State || "").trim() ? elakayAutoText("h_uart_addressFieldRequired", "This field is required.") : null,
                    city: touchedAddressFields.city && !String(city || "").trim() ? elakayAutoText("h_uart_addressFieldRequired", "This field is required.") : null,
                }}
            />

            <div className="uart-field uart-address-field uart-address-field--full">
                <label htmlFor="uart-address-line1">{infoSource.laguangeElakay("label", infoSource.languageAPI).Address1}</label>
                <input id="uart-address-line1" className="form-control" type="text" autoComplete="address-line1" value={Address1 || ""} onChange={handleAddressChange("Address1")} onBlur={touchAddressField("Address1")} aria-invalid={touchedAddressFields.Address1 && !Address1 ? "true" : "false"} />
                {fieldError("Address1", Address1) || <p className="uart-field-hint">{elakayAutoText("h_formaddress_hint_address1", "Street number and name (e.g. 123 Main St).")}</p>}
            </div>

            <div className="uart-field uart-address-field uart-address-field--full">
                <label htmlFor="uart-address-line2">{elakayAutoText("h_addrloc_address2", "Apartment, suite, unit (optional)")}</label>
                <input id="uart-address-line2" className="form-control" type="text" autoComplete="address-line2" value={adress.Address2 || ""} onChange={handleAddressChange("Address2")} />
            </div>

            <div className="uart-field uart-address-field">
                <label htmlFor="uart-address-firstname">{infoSource.laguangeElakay("label", infoSource.languageAPI).fisrtName}</label>
                <input id="uart-address-firstname" className="form-control" type="text" autoComplete="given-name" value={firstName || ""} onChange={handleAddressChange("firstName")} onBlur={touchAddressField("firstName")} aria-invalid={touchedAddressFields.firstName && !firstName ? "true" : "false"} />
                {fieldError("firstName", firstName) || <p className="uart-field-hint">{elakayAutoText("h_formaddress_hint_firstname", "First name of the person at this address.")}</p>}
            </div>

            <div className="uart-field uart-address-field">
                <label htmlFor="uart-address-lastname">{infoSource.laguangeElakay("label", infoSource.languageAPI).lastName}</label>
                <input id="uart-address-lastname" className="form-control" type="text" autoComplete="family-name" value={lastName || ""} onChange={handleAddressChange("lastName")} onBlur={touchAddressField("lastName")} aria-invalid={touchedAddressFields.lastName && !lastName ? "true" : "false"} />
                {fieldError("lastName", lastName) || <p className="uart-field-hint">{elakayAutoText("h_formaddress_hint_lastname", "Last name of the person at this address.")}</p>}
            </div>

            {CommercialRole() && (
                <div className="uart-field uart-address-field">
                    <label htmlFor="uart-address-shopname">{infoSource.laguangeElakay("label", infoSource.languageAPI).shopName}</label>
                    <input id="uart-address-shopname" className="form-control" type="text" value={shopName || ""} onChange={handleAddressChange("shopName")} />
                </div>
            )}

            {userInfo.telephone && userInfo.telephone.length > 0 && (
                <div className="uart-field uart-address-field">
                    <label htmlFor="uart-address-tel">{infoSource.laguangeElakay("label", infoSource.languageAPI).phone}</label>
                    <select id="uart-address-tel" className="form-control" value={tel || ""} onChange={handleAddressChange("tel")}>
                        <option value="">{infoSource.laguangeElakay("label", infoSource.languageAPI).pleaseSelect}</option>
                        {userInfo.telephone.map((p, i) => (
                            <option key={p._id || i} value={p.International}>{p.International}</option>
                        ))}
                    </select>
                    <p className="uart-field-hint">{elakayAutoText("h_formaddress_hint_phone", "A phone number where you can be reached about this address.")}</p>
                </div>
            )}
        </div>

        <div className="uart-alert uart-alert-info uart-address-banner" role="note">
            <FaInfoCircle className="uart-address-banner-icon" aria-hidden="true" />
            <span>{elakayAutoText("h_uart_addressAccuracyHint", "Make sure your address is accurate to ensure smooth delivery.")}</span>
        </div>

        {modalFooter('address', elakayAutoText("h_uart_saveChanges", "Save changes"), !addressValid)}
    </div>
}

    const allForm = ()=>{
       return <div className="uart-edit-form">
         {showError()}
        <form onSubmit={(e) => e.preventDefault()}>

        {editShoose === 'email' && emailForm()}
       {editShoose === 'fullName' && firtLastName()}
       {editShoose === 'passWord' &&  passwordForm()}
       {editShoose === 'telephone' &&  telephoneForm()}
       {editShoose === 'address' &&  adressForm()}
        </form>
        </div>
    }

    return (
       <>

       { allForm() }
       </>
    );
};

export default PageEditForm;
